"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_MESSAGE = void 0;
exports.ERROR_MESSAGE = {
    REQUIRE_INIT: 'You need to call liff.init first.',
    REQUIRE_LOGIN: 'You need to call liff.login first.',
};
